export const FETCH_BLOGS = "BLOG_MANAGEMENT/FETCH_BLOGS";
export const ANALYZE_BLOG_PAGE = "BLOG_MANAGEMENT/ANALYZE_BLOG_PAGE";
export const UPDATE_BLOG_PAGE_STATUS = "BLOG_MANAGEMENT/UPDATE_BLOG_PAGE_STATUS";
